import { jsx as _jsx } from "react/jsx-runtime";
import { Command } from "@air/cmdk";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const SearchCommandItem = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(Command.Item, {
        className: tailwindMerge("group/command-item flex cursor-pointer items-center gap-2 rounded-4 p-2 text-14 transition-colors data-[selected=true]:bg-grey-4 hover:bg-grey-4", className),
        "data-testid": "SEARCH_COMMAND_ITEM",
        ...restOfProps
    });
});
SearchCommandItem.displayName = "SearchCommandItem";
